// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3sHW8","boxTitle":"Qualiphy_boxTitle__3LupA","box":"Qualiphy_box__UuuOY","toggleWrap":"Qualiphy_toggleWrap__2ZdIU"};